import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

enum FINANCES_ROUTE_NAMES {
  cashDocuments = "Cash Documents",
  cashReports = "Cash Reports",
  requestsForPayment = "Requests For Payment",
  creditCardStatements = "Credit Card Statements",
  bankStatementItem = "Bank Statement Items",
  bankTransfers = "Bank Transfers",
  bankOperationsSale = "Bank Operations Sale",
  bankOperationsPurchase = "Bank Operations Purchase",
}

const FinancesRoutes: Array<CustomRouteConfig> = [
  {
    name: FINANCES_ROUTE_NAMES.cashDocuments,
    path: "finances/cash-documents",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceCashDocumentsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesCashDocumentsView.vue"),
  },
  {
    name: FINANCES_ROUTE_NAMES.cashReports,
    path: "finances/cash-reports",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceCashReportsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesCashReportsView.vue"),
  },
  {
    name: FINANCES_ROUTE_NAMES.requestsForPayment,
    path: "finances/requests-for-payment",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceOverduePaymentsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesRequestsForPayment.vue"),
  },
  {
    name: FINANCES_ROUTE_NAMES.creditCardStatements,
    path: "finances/credit-card-statements",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceCreditCardsStatementsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesCreditCardStatementsView.vue"),
  },
  {
    name: FINANCES_ROUTE_NAMES.bankStatementItem,
    path: "finances/bank-statement-items",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceBankStatementsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesBankOperationsSaleView.vue"),
  },
  {
    name: FINANCES_ROUTE_NAMES.bankTransfers,
    path: "finances/bank-transfers",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceBankStatementsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesBankTransfers.vue"),
  },
  {
    name: FINANCES_ROUTE_NAMES.bankOperationsSale,
    path: "finances/bank-operations-sale",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceBankStatementsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesBankOperationsSaleView.vue"),
  },
  {
    name: FINANCES_ROUTE_NAMES.bankOperationsPurchase,
    path: "finances/bank-operations-purchase",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceBankStatementsRead] },
    component: () =>
      import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesBankOperationsPurchaseView.vue"),
  },
  {
    name: "Finances",
    path: "finances",
    meta: { hasOneOfPermissions: [PERMISSIONS.FinanceCashDocumentsRead] },
    component: () => import(/* webpackChunkName: "finances" */ "@/views/finances/FinancesView.vue"),
  },
];

export { FinancesRoutes, FINANCES_ROUTE_NAMES };
export default FinancesRoutes;
